<template>
  <div class="md-layout">
    <!-- 模板 -->
    <div class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto" style="margin-top: -30px;">
      <div style="box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);">
        <simple-wizard :start-index="startIndex" @update:startIndex="updateIndex">
          <!-- 添加按钮 -->
          <template slot="header">
            <div></div>
          </template>
          <!-- 1 体系管理 -->
          <wizard-tab >
            <template slot="label"> {{$I18n("sys")}} </template>
            <md-card class="md-card-only-title">
              <md-card-content>
                <add-button @click="table_addItem">{{$I18n("add")}}</add-button>
              </md-card-content>
            </md-card>
            <!-- ID   名称   体系ID   创建时间 -->
            <md-table v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('sys')">{{ item.sys }}</md-table-cell>
                <md-table-cell :md-label="$I18n('created_time')">{{ item.create_time }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                  <md-button class="md-just-icon md-round md-info"
                    @click.stop="table_editItem(item)"
                    ><md-icon>edit</md-icon></md-button
                  >
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
            <!-- 翻页 -->
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </wizard-tab>
          <!-- 2 数据中心 -->
          <wizard-tab >
            <template slot="label"> {{$I18n("datacenter")}} </template>
            <!-- <div class="md-layout card-form" style="max-width: 200px;margin-bottom: 2px;">
              <div class="md-layout-item md-size-100 left-layout-item md-xsmall-size-100">
                <md-field>
                  <md-select v-model="deploy_open">
                    <md-option :value="1">{{$I18n('deployed')}}</md-option>
                    <md-option :value="2">{{$I18n('no_deployed')}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-button class= "left-icon md-info" @click="form_search">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
              </div>
            </div> -->
            <md-card class="md-card-only-title">
              <md-card-content>
                <add-button @click="table_addItem">{{$I18n("add")}}</add-button>
              </md-card-content>
            </md-card>
            <!-- ID   名称   域名  状态  访问地址  端口  TLS端口 H5地址 更新时间   创建时间 -->
            <md-table v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('zone')">{{ item.zone }}</md-table-cell>
                <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('domain_prefix')">{{ item.domain_prefix }}</md-table-cell>
                <md-table-cell :md-label="$I18n('domain')">{{ item.domain }}</md-table-cell>
                <!-- <md-table-cell :md-label="$I18n('ips')">{{ item.ips_list }}</md-table-cell> -->
                <md-table-cell :md-label="$I18n('port')">{{ item.port }}</md-table-cell>
                <md-table-cell :md-label="$I18n('ssl_port')">{{ item.ssl_port }}</md-table-cell>
                <md-table-cell :md-label="$I18n('h5_host')">{{ item.h5_host }}</md-table-cell>
                <md-table-cell :md-label="$I18n('created_time')">{{ item.create_time }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                  <md-button @click.stop="table_editItem(item)" class="md-just-icon md-round md-info">
                    <md-icon>edit</md-icon>
                  </md-button>
                  <md-button @click.stop="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info left-icon">
                    <md-icon>close</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
            <!-- 翻页 -->
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </wizard-tab>
          <!-- 3 区域绑定 -->
          <wizard-tab >
            <template slot="label"> {{$I18n("zone_bind")}} </template>
            <div class="md-layout card-form" style="max-width: 200px;margin-bottom: 2px;">
              <div class="md-layout-item md-size-100 left-layout-item md-xsmall-size-100">
                <md-field>
                  <md-select v-model="formData.zone_type">
                    <md-option :value="30">{{$I18n('acc_ser')}}</md-option>
                    <md-option :value="12">{{$I18n('p2p_ser')}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- <div class="md-layout-item md-size-25">
                <md-button class= "left-icon md-info" @click="form_search">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
              </div> -->
            </div>
            <md-card class="md-card-only-title">
              <md-card-content>
                <add-button @click="table_addItem">{{$I18n("add")}}</add-button>
              </md-card-content>
            </md-card>
            <md-table v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('source_area_type')">{{ item.src_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('the_code')">{{ item.src_area }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.src_area_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('object_area_type')">{{ item.dest_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('the_code')">{{ item.dest_area }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.dest_area_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('remarks')">{{ item.remark }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                  <md-button
                    @click.stop="table_editItem(item)"
                    class="md-just-icon md-round md-info"
                    ><md-icon>edit</md-icon></md-button
                  >
                  <md-button
                    @click.stop="table_deleteItem(item)"
                    class="md-just-icon md-round md-danger md-info left-icon"
                    ><md-icon>close</md-icon></md-button
                  >
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
            <!-- 翻页 -->
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
    <!-- 弹窗 -->
    <simple-modal ref="modal" :title="modalTitle" :right="openModalType!=='delete'" @submit="modal_submit">
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", '')}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <div class="" style="position: relative;" slot="zone">
              <div style="position:absolute; top:0; bottom: 0; left: 0; right: 0;z-index: 1;cursor: pointer;" @click="() => openSelectZone()"></div>
              <md-field>
                <!-- 可修改 -->
                <md-select v-model="modalData.Form.zone">
                  <md-option value="ALL">{{$I18n("all")}}</md-option>
                  <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                    lang === "zh" ?item.cn_name :item.name
                  }}</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="" style="position: relative;" slot="src_area" v-if="modalData.Form.src_type == 2">
              <div style="position:absolute; top:0; bottom: 0; left: 0; right: 0;z-index: 1;cursor: pointer;" @click="() => openSrcZone()"></div>
              <md-field>
                <!-- 可修改 -->
                <md-select v-model="modalData.Form.src_area">
                  <md-option value="ALL">{{$I18n("all")}}</md-option>
                  <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                    lang === "zh" ?item.cn_name :item.name
                  }}</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="" style="position: relative;" slot="dest_area" v-if="modalData.Form.dest_type == 2">
              <div style="position:absolute; top:0; bottom: 0; left: 0; right: 0;z-index: 1;cursor: pointer;" @click="() => openDestZone()"></div>
              <md-field>
                <!-- 可修改 -->
                <md-select v-model="modalData.Form.dest_area">
                  <md-option value="ALL">{{$I18n("all")}}</md-option>
                  <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                    lang === "zh" ?item.cn_name :item.name
                  }}</md-option>
                </md-select>
              </md-field>
            </div>
          </common-form-item>
        </div>
      </template>
    </simple-modal>
    <zone-select-modal ref="zoneselect" @select="zone => (modalData.Form.zone = zone)"/>
    <zone-select-modal ref="srcselect"  @select="zone => (modalData.Form.src_area = zone)"/>
    <zone-select-modal ref="destselect" @select="zone => (modalData.Form.dest_area = zone)"/>
  </div>
</template>
<script>
import { SimpleWizard, WizardTab } from "@/components";
import { timestampToString1000, FormClass } from "@/common/tools.js";
import ZoneSelectModal from "@/components/Common/ZoneSelectModal";
import {countryArray, continentArray} from "@/common/continent.js";

export default {
  components: {
    ZoneSelectModal,
    SimpleWizard,
    WizardTab,
  },
  props:["userinfo_sys", "userinfo_database"],
  data() {
    return {
      // deploy_open : 1, 
      lang : this.$router.history.current.query.lang,
      countryArray,
      continentArray,
      sysOptions:[],
      startIndex: 0,
      formData:{
        zone_type: 30,
      },
      // 表格相关
      ...({
        searchData : {
          type: "sys",
        },
        icon  : "computer",
        title : this.$I18n("user"),
        tableInitData : [], // 表格数据
        // 分页相关
        pageSize : 10,
        currentPage : 1,
        total : 0,
        // 弹窗相关
        openModalType : "upload", // 弹窗类型
        modalTitle : "",  // 弹窗标题
      }),
      // 弹窗表单相关
      modalData : new FormClass({
        /*SYS*/
          name : {
            init: "",
              check: value => {
                if(this.searchData.type === "datacenter" || this.searchData.type === "sys"){
                  return !value;
                }
              },
          },
          // DATA CENTER 也有
          sys : {
            init: "",
            check: value => {
              if(this.searchData.type === "sys"){
                return !value;
              }
              if((this.searchData.type === "datacenter" || this.searchData.type === "zonebind") && this.sysOptions.length > 1){
                return !value;
              }
            },
          },
        /*DATA CENTER*/
          deploy_open:1,
          // state: 1, // 下面有了
          h5_host: "",
          zone : {
            init: "",
            check: value => {
              if(this.searchData.type === "datacenter"){
                return !value;
              }
            },
          },
          domain_prefix : {
            init: "",
            check: value => {
              if(this.searchData.type === "datacenter"){
                return !value;
              }
            },
          },
          domain : {
            init: "",
            check: value => {
              if(this.searchData.type === "datacenter"){
                return !value;
              }
            },
          },
          port : {
            init: "",
            check: value => {
              if(this.searchData.type === "datacenter"){
                return isNaN(value) || value === "" || parseInt(value) <= 0;
              }
            },
          },
          ssl_port : {
            init: "",
            check: value => {
              if(this.searchData.type === "datacenter"){
                return isNaN(value) || value === "" || parseInt(value) <= 0;
              }
            },
          },
          ips_list: {
            init : () => {return []},
            check: value => {
              if(this.searchData.type === "datacenter"){
                return value.length === 0;
              }
            },
          },
        /*ZONE BIND*/
          src_type : 1,
          dest_type : 2,
          state : 1,
          type: 30,
          src_area : {
            init: "",
            check: value => {
              if(this.searchData.type === "zonebind"){
                return !value;
              }
            },
          },
          dest_area : {
            init: "",
            check: value => {
              if(this.searchData.type === "zonebind"){
                return !value;
              }
            },
          },
          remark : {
            init: "",
          },
      }),
      continent : {
        "AF" : this.$I18n("africa"),
        "EU" : this.$I18n("europe"),
        "AS" : this.$I18n("asia"),
        "OA" : this.$I18n("oceania"),
        "NA" : this.$I18n("north_america"),
        "SA" : this.$I18n("latin_america"),
        "AN" : this.$I18n("antarctica"),
        "OC" : this.$I18n("oceania"),
      },
    };
  },
  mounted : function() {
    this.api_getPageData();
    this.api_getSys();
  },
  watch: {
    // deploy_open(){
    //   this.api_getPageData();
    // },
    userinfo_sys(newValue){
      this.modalData.SetInit(newValue, "sys")
    },
    formData:{
      handler(){
        this.api_getPageData();
        return 
      },
      immediate: true,
      deep: true,
    },
    userinfo_database(){
      this.api_getSys();
    },
    currentPage() {
      this.api_getPageData();
    },
    startIndex(newValue){
      if(newValue === 0){        // 体系
        this.searchData.type = "sys";
      } else if(newValue === 1){ // 数据中心
        this.searchData.type = "datacenter";
      } else if(newValue === 2){ // 区域绑定
        this.searchData.type = "zonebind";
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
  },
  methods: {
    openSrcZone(){
      this.$refs.srcselect.open();
    },
    openDestZone(){
      this.$refs.destselect.open();
    },
    openSelectZone(){
      this.$refs.zoneselect.open();
    },
    api_getSys(){
      return this.$api.getSysList({
        type  : "sys",
        option: {},
      })
        .then(this.$Then(res => {
          this.sysOptions = res.data;
          this.modalData.SetInit(this.userinfo_sys, "sys")
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.sysOptions = [];
        }))
    },
    updateIndex(newIndex){
      this.startIndex = newIndex;
    },
    table_addItem(){
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      if(this.searchData.type === "sys"){
        this.modalData.Form.sys = "";
      }
      this.openModalType = "add";
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      this.modalData.ResetUpdate({...item});
      this.openModalType = "edit";
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.ResetUpdate({...item});
      this.openModalType = "delete";
      this.$refs.modal.open();
    },
    // 获取页面信息
    api_getPageData(){
      let postData = {
        ...this.searchData,
        option    : {
          sys     : this.searchData.type === 'sys' && this.UserInfo && this.UserInfo.role_id < 10000 
            ?"" 
            :this.userinfo_sys,
          // deploy_open: this.searchData.type === 'datacenter' ?parseInt(this.deploy_open) :"",
        },
        page_size : this.pageSize,
        page_no   : this.currentPage,
      }
      if(this.searchData.type === "zonebind"){
        postData.option.type = this.formData.zone_type;
      }
      if(this.searchData.type === 'sys'){
        this.api_getSys();
      }
      // 获取角色
      this.$api.getSysList(postData)
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.$refs.modal.close();
    },
    api_submit_success_reslut(){
      this.$successMsg(this.$I18n("succ_num"));
      this.modal_classicModalHide();
      this.api_getPageData();
      this.$root.state.toggle_datacenter = !this.$root.state.toggle_datacenter;
    },
    // 提交表单
    modal_submit () {
      if(this.openModalType !== "delete" && this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_input_content"));
        return;
      }
      // let opcode = 1;
      if(this.openModalType === "add"){
        this.$api.addSysList({
          type: this.searchData.type,
          option: {
            ...this.modalData.Form,
            ips: JSON.stringify(this.modalData.Form.ips_list),
          },
        })
          .then(this.$Then(this.api_submit_success_reslut))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType === "edit"){
        this.$api.setSysList({
          type: this.searchData.type,
          option: {
            ...this.modalData.Form,
            ips: JSON.stringify(this.modalData.Form.ips_list),
          },
        })
          .then(this.$Then(this.api_submit_success_reslut))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType === "delete"){
        this.$api.delSysList({
          type: this.searchData.type,
          option: {
            ...this.modalData.Form,
            zone: (this.searchData.type === "zonebind"||this.searchData.type === "datacenter") ?this.modalData.Form.zone:"",
            sys : (this.searchData.type === "zonebind"||this.searchData.type === "datacenter") ?this.modalData.Form.sys :"",
            // zonebind
            src_area: this.searchData.type === "zonebind" ?this.modalData.Form.src_area :"",
            src_type: this.searchData.type === "zonebind" ?this.modalData.Form.src_type :"",
            type    : this.searchData.type === "zonebind" ?this.modalData.Form.type :"",
          },
        })
          .then(this.$Then(this.api_submit_success_reslut))
          .catch(this.$Catch(this.$I18n("fail_num")))
      }
    },
  },
  computed: {
    form_modalData(){
      if(this.searchData.type === "sys"){
        return [
          {
            label   : this.$I18n("name"),
            keys    : "name",
            type    : "input",
            check   : true,
            required: true
          },{
            label   : this.$I18n("sys"),
            keys    : "sys",
            type    : "input",
            check   : true,
            required: true,
          },
        ]
      } else if (this.searchData.type === "datacenter"){
        return [
          {
            label   : this.$I18n("name"),
            keys    : "name",
            type    : "input",
            check   : true,
            required: true
          },{
            label   : this.$I18n("sys"),
            keys    : "sys",
            type    : "select",
            check   : true,
            required: true,
            options : this.sysOptions.map(i => {
              return {id: i.sys, name: i.name}
            }),
            hide    : this.openModalType === "edit",
          },{
            label   : this.$I18n("zone"),
            keys    : "zone",
            type    : "input",
            check   : true,
            required: true,
          },{
            label   : this.$I18n("state"),
            keys    : "state",
            type    : "select",
            options : [
              {id: 1, name: this.$I18n("open")},
              {id: 2, name: this.$I18n("closed")},
            ],
            required: true,
          },{
            label   : this.$I18n("domain_prefix"),
            keys    : "domain_prefix",
            type    : "input",
            check   : true,
            required: true,
          },{
            label   : this.$I18n("domain"),
            keys    : "domain",
            type    : "input",
            check   : true,
            required: true,
          },{
            label   : this.$I18n("ips"),
            keys    : "ips_list",
            type    : "chips",
            check   : true,
            required: true,
          },{
            label   : this.$I18n("port"),
            keys    : "port",
            type    : "input",
            check   : true,
            required: true,
          },{
            label   : this.$I18n("ssl_port"),
            keys    : "ssl_port",
            type    : "input",
            check   : true,
            required: true,
          },{
            label   : this.$I18n("h5_host"),
            keys    : "h5_host",
            type    : "input",
            placeholder: "https://h5.abc.com",
          },{
            label   : "CDN",
            keys    : "cdn_host",
            type    : "input",
            placeholder: "http://cdn.abc.com",
          },{
            label   : this.$I18n("deploy_open"),
            keys    : "deploy_open",
            type    : "select",
            options : [
              {id: 1, name: this.$I18n("deployed")},
              {id: 2, name: this.$I18n("no_deployed")},
            ],
            required: true,

          }
        ]
      } else if (this.searchData.type === "zonebind"){
        return [
          {
            label   : this.$I18n("sys"),
            keys    : "sys",
            type    : "select",
            check   : true,
            required: true,
            options : this.sysOptions.map(i => {
              return {id: i.sys, name: i.name}
            }),
            hide    : this.openModalType === "edit",
          },{
            label   : this.$I18n("type"),
            keys    : "type",
            type    : "select",
            options : [
              {
                id  : "30",
                name: this.$I18n('acc_ser'),
              },{
                id  : "12",
                name: this.$I18n('p2p_ser'),
              }
            ],
            hide    : this.openModalType !== 'add'
          },{
            label   : this.$I18n("source_area_type"),
            keys    : "src_type",
            type    : "select",
            options : [
              {
                id  : 1,
                name: this.$I18n('continent'),
              },{
                id  : 2,
                name: this.$I18n('country'),
              }
            ],
            required: true
          },{
            label   : this.$I18n("source_area_code"),
            keys    : "src_area",
            type    : "select",
            options : continentArray.map(i => {
              return {id: i.code, name: this.lang === "zh" ?i.cn_name :i.name}
            }),
            check   : true,
            required: true
          },{
            label   : this.$I18n("object_area_type"),
            keys    : "dest_type",
            type    : "select",
            options : [
              {
                id  : 1,
                name: this.$I18n('continent'),
              },{
                id  : 2,
                name: this.$I18n('country'),
              }
            ],
            required: true
          },{
            label   : this.$I18n("object_area_code"),
            keys    : "dest_area",
            type    : "select",
            options : continentArray.map(i => {
              return {id: i.code, name: this.lang === "zh" ?i.cn_name :i.name}
            }),
            check   : true,
            required: true
          },{
            label   : this.$I18n("state"),
            keys    : "state",
            type    : "select",
            options : [
              {
                id  : 1,
                name: this.$I18n('is_use'),
              },{
                id  : 2,
                name: this.$I18n('is_not_use'),
              }
            ],
            required: true
          },{
            label   : this.$I18n("remarks"),
            keys    : "remark",
            type    : "textarea",
          }
        ]
      } else {
        return [];
      }
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        if(this.searchData.type === "zonebind"){
          return [...this.tableInitData]
            // .splice((this.currentPage-1) * this.pageSize, this.pageSize)
            .map(item => {
              let type_name  = ""
              switch(item.src_type){
                case 1:
                  type_name = this.$I18n("acc_ser");
                  break
                case 2:
                  type_name = this.$I18n("p2p_ser");
                  break;
                default:
                  type_name = this.$I18n("unknow");
                  break;
              }

              let src_type_name  = ""
              switch(item.src_type){
                case 1:
                  src_type_name = this.$I18n("continent");
                  break
                case 2:
                  src_type_name = this.$I18n("country");
                  break;
                default:
                  src_type_name = this.$I18n("unknow");
                  break;
              }

              let dest_type_name = ""
              switch(item.dest_type){
                case 1:
                  dest_type_name = this.$I18n("continent");
                  break
                case 2:
                  dest_type_name = this.$I18n("country");
                  break;
                default:
                  dest_type_name = this.$I18n("unknow");
                  break;
              }
              let src_area_name  = item.src_type == 2 ?this.$I18n(item.src_area) : this.continent[item.src_area]
              if (!src_area_name || src_area_name.indexOf("zh.") > -1 || src_area_name.indexOf("en.") > -1){
                src_area_name = item.src_area
              }
              let dest_area_name = item.dest_type == 2 ?this.$I18n(item.dest_area) : this.continent[item.dest_area]
              if (!dest_area_name || dest_area_name.indexOf("zh.") > -1 || dest_area_name.indexOf("en.") > -1){
                dest_area_name = item.dest_area
              }
              let state_name     = ""
              switch(item.state){
                case 1:
                  state_name = this.$I18n("is_use");
                  break
                case 2:
                  state_name = this.$I18n("is_not_use");
                  break;
                default:
                  state_name = this.$I18n("is_not_use");
                  break;
              }

              return {
                type_name,
                src_type_name,
                dest_type_name,
                src_area_name,
                dest_area_name,
                state_name,
                ... item,
              }
            })
        } 

        return [...this.tableInitData]
          .map(item => {
            if(this.searchData.type === "datacenter"){
              let state_name = "";
              switch(item.state){
                case 1:
                  state_name = this.$I18n("open");
                  break;
                case 2:
                  state_name = this.$I18n("closed");
                  break;
                default:
                  item.state = 2;
                  state_name = this.$I18n("closed");
                  break;
              }
              if(item.ips){
                return {
                  ... item,
                  state_name,
                  ips_list   : JSON.parse(item.ips),
                  create_time: timestampToString1000(item.gmt_create),
                }
              } else {
                return {
                  ... item,
                  state_name,
                  ips_list:[],
                  create_time: timestampToString1000(item.gmt_create),
                }
              }
            }
            return {
              ... item,
              create_time: timestampToString1000(item.gmt_create),
            }
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>